import { AccountContactTypes } from 'components/accountContact/helpers/constants'
import { AccountContactData, AccountContactFormData } from 'components/accountContact/helpers/types'
import { getAccountContactPayload } from 'components/accountContact/helpers/utils'

export const getAccountRepPayload = (
  accountContactData: AccountContactData,
  formValues: AccountContactFormData,
  isSecondNationalityEnabled: boolean
): AccountContactData => {
  const sharedData = getAccountContactPayload({
    initialData: accountContactData,
    formValues,
    isSecondNationalityEnabled,
  })
  const updatedData: AccountContactData = {
    type: AccountContactTypes.ACCOUNT_REPRESENTATIVE,
    person: sharedData?.person,
    contactInfo: {
      emailAddress: formValues?.emailAddress,
    },
  }
  updatedData.person.reference = null
  return updatedData
}
